import get from 'lodash/get'

export const CHANGE_PASSWORD_ROUTE="/change-password";
export const FIRST_TIME_CHANGE_PASSWORD_ROUTE="/first-time-change-password"
export const LOGIN_ROUTE="/"
export const MFA_SETUP_ROUTE="/mfa-setup"
export const MFA_VERIFICATION_ROUTE="/mfa-verification"
export const FORGOT_PASSWORD_ROUTE="/reset-password"
export const FORGOT_CONFIRM_PASSWORD_ROUTE="/reset-confirm-password"

export const FORGOT_CONFIRM_OTP_PASSWORD_ROUTE="/reset-confirm-password-otp"


export const HOMEPAGE_ROUTE="/homepage"

export const OPERATOR_ROUTE=()=>(get(OPERATOR_LINKS,env))

export const env=process.env.REACT_APP_STAGE

export const OPERATOR_LINKS={
    DEV:"https://dev-cubs.dslmonitoring.net/userBanSearch",
    TEST:"https://dev-cubs.dslmonitoring.net/userBanSearch",
    UAT:"https://uat-cubs.dslmonitoring.net/userBanSearch",
    PROD:"https://cubs.dslmonitoring.net/userBanSearch"
    }
export const APP_LINKS = {
    DEV:{
        DASHBOARD:"http://localhost:3001",
        CASE_RETREIVAL:"http://localhost:3003/caseretreival/",
        LAYER_UPLOAD:"http://localhost:3002/geoupload/",
        CLR_UPLOAD:"http://dev-cubs.dslmonitoring.net"
    },
    TEST:{
        DASHBOARD:"https://dslmontioring.net:3338/dashboard/",
        CASE_RETREIVAL:"https://dslmonitoring.net:3338/caseretreival/",
        LAYER_UPLOAD:"https://dslmonitoring.net:3338/geoupload/",
        CLR_UPLOAD:"https://dev-cubs.dslmonitoring.net"
    },
    UAT:{
        DASHBOARD:"https://dslmonitoring.net:3438/dashboard/",
        CASE_RETREIVAL:"https://dslmonitoring.net:3438/caseretrieval/",
        LAYER_UPLOAD:"https://dslmonitoring.net:3438/geoupload/",
        CLR_UPLOAD:"https://uat-cubs.dslmonitoring.net"
    },
    PROD:{
        DASHBOARD:"https://dslmonitoring.net/dashboard/",
        CASE_RETREIVAL:"https://dslmonitoring.net/caseretrieval/",
        LAYER_UPLOAD:"https://dslmonitoring.net/geoupload/",
        CLR_UPLOAD:"https://cubs.dslmonitoring.net/"
    },
}

export const getDashboardLink = ()=>get(APP_LINKS,env).DASHBOARD
export const getCaseRetrivalLink = ()=>get(APP_LINKS,env).CASE_RETREIVAL
export const getLayerUploadLink = ()=>get(APP_LINKS,env).LAYER_UPLOAD
export const getCLRUploadLink = ()=>get(APP_LINKS,env).CLR_UPLOAD


export const getScanName = ()=> env === "PROD"?"DSLMonitoring:":`${env}_DSLMonitoring:`

